var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoibin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5463 40.1131C14.1426 40.1159 13.7386 39.961 13.4354 39.6492C13.3223 39.5329 13.2096 39.4169 13.0971 39.3013C12.6575 38.8719 12.2293 38.4475 11.8116 38.0127C11.5291 37.7187 11.2494 37.4225 10.9725 37.1241C10.8403 36.9893 10.708 36.8547 10.5756 36.7201C10.5048 36.6481 10.4535 36.5582 10.3858 36.4834C8.03868 33.886 5.9149 31.1139 4.12707 28.0848C3.02694 26.2212 2.09255 24.2895 1.42425 22.2464C1.38209 22.1175 1.32629 21.9935 1.27511 21.868C1.23399 21.767 1.19714 21.6555 1.16269 21.5324C0.909968 20.6295 0.720926 19.7317 0.603711 18.8389C0.491228 18.03 0.447044 17.2255 0.467888 16.4321C0.509471 14.5149 0.923573 12.6205 1.79331 10.7471C3.29709 7.50759 5.93975 5.10159 9.03755 3.78825C10.8213 3.01392 12.6946 2.65032 14.5462 2.65532C16.398 2.65031 18.2713 3.01391 20.0551 3.78826C23.1528 5.1016 25.7955 7.5076 27.2993 10.7471C28.169 12.6205 28.5831 14.515 28.6247 16.4321C28.6455 17.2255 28.6014 18.0299 28.4889 18.8388C28.3717 19.7316 28.1826 20.6295 27.9299 21.5324C27.8954 21.6555 27.8586 21.767 27.8175 21.868C27.7663 21.9935 27.7105 22.1175 27.6683 22.2464C27 24.2895 26.0656 26.2212 24.9655 28.0848C23.1777 31.114 21.0539 33.886 18.7067 36.4834C18.6391 36.5583 18.5877 36.6482 18.517 36.7201C18.3846 36.8547 18.2523 36.9893 18.1201 37.1241C17.8432 37.4225 17.5635 37.7187 17.281 38.0127C16.8633 38.4475 16.4351 38.8718 15.9955 39.3013C15.883 39.4169 15.7703 39.5329 15.6572 39.6492C15.354 39.961 14.95 40.1159 14.5463 40.1131ZM14.5463 23.7579C10.6666 23.7562 7.53462 20.6173 7.54058 16.7323C7.54655 12.8707 10.6805 9.74227 14.5463 9.7344C18.4121 9.74227 21.546 12.8707 21.552 16.7323C21.558 20.6173 18.426 23.7562 14.5463 23.7579Z",
    fill: "url(#paint0_linear_3177_42971)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5442 21.5249C11.8986 21.5204 9.77166 19.3875 9.7754 16.7419C9.77838 14.1038 11.9217 11.9687 14.5628 11.9717C17.2054 11.9747 19.3301 14.1113 19.3249 16.7606C19.3197 19.4137 17.1972 21.5294 14.5442 21.5249Z",
    fill: "url(#paint1_linear_3177_42971)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.035 16.2258C32.1998 16.2258 35.5819 12.8667 35.5819 8.7159C35.5819 4.56506 32.1998 1.20596 28.035 1.20596C23.8702 1.20596 20.4882 4.56506 20.4882 8.7159C20.4882 12.8667 23.8702 16.2258 28.035 16.2258Z",
    fill: "url(#paint2_linear_3177_42971)",
    stroke: "white",
    strokeWidth: 1.27363
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8484 6.6322C31.1164 6.85674 31.1517 7.25604 30.9271 7.52405L27.9217 11.1113C27.812 11.2423 27.654 11.3233 27.4836 11.3361C27.3133 11.3489 27.145 11.2922 27.017 11.1791L25.2138 9.58472C24.9518 9.35312 24.9272 8.95302 25.1588 8.69108C25.3904 8.42913 25.7905 8.40453 26.0524 8.63613L27.3686 9.79983L29.9566 6.71091C30.1811 6.44289 30.5804 6.40765 30.8484 6.6322Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3177_42971",
    x1: -1.42605,
    y1: 7.96679,
    x2: 28.9259,
    y2: 36.4961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00754A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3177_42971",
    x1: 9.13498,
    y1: 13.3263,
    x2: 16.7022,
    y2: 22.7817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00754A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3177_42971",
    x1: 20.1982,
    y1: 3.79199,
    x2: 31.073,
    y2: 17.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28123"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoibin);
export default __webpack_public_path__ + "static/media/POIBIN.a1ef01a2167df83b3d4c6b0737853545.svg";
export { ForwardRef as ReactComponent };